// Rutgers University-Newark's bachelor's majors (#2739). Read on 2026-10-01
// from Rutgers' official 2026-2027 Newark Undergraduate Catalog
// (newark-undergrad-26-27.catalogs.rutgers.edu; the full text was read from
// the catalog's own Download Catalog as PDF file, which is hosted off .edu, so
// the groups cite the catalog site): Newark College of Arts and Sciences,
// Programs of Study (University College-Newark's chapter repeats the same
// list); Rutgers Business School: Undergraduate-Newark, Academic Program
// Requirements ("seven majors leading to the Bachelor of science (B.S.)");
// School of Public Affairs and Administration, Undergraduate Major in Public
// Administration (B.A.). The catalog does not name the School of Criminal
// Justice's degrees, so those two come from the school's Undergraduate page.
// Health Information Management carries no degree in the list; its catalog
// section calls it "a bachelor of science degree program". Degree
// abbreviations are the catalog's. Left out: specializations (Art History,
// Fine Arts, the Biology tracks, Medical Laboratory Sciences, Cardiac and
// Diagnostic Sonography, Graphic Design), business concentrations and the
// Finance tracks, minors, and the joint and accelerated bachelor's and
// master's programs (B.S./M.A., B.A./M.P.A.).
const majors = {
    "slug": "rutgers-university-newark",
    "read": "2026-10-01",
    "intro": "Every bachelor's major in Rutgers University-Newark's official undergraduate catalog, by school, with the degree it leads to. Specializations, concentrations, minors and joint bachelor's and master's programs are left out.",
    "groups": [
        {
            "name": "Newark College of Arts and Sciences",
            "source": {
                "label": "Rutgers Newark Undergraduate Catalog 2026-2027, Newark College of Arts and Sciences, Programs of Study",
                "url": "https://newark-undergrad-26-27.catalogs.rutgers.edu/"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Art",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Clinical Laboratory Science",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Science",
                    "degree": "B.S."
                },
                {
                    "name": "ESL and Bilingual/Bicultural Urban Education",
                    "degree": "B.A."
                },
                {
                    "name": "Geology",
                    "degree": "B.A."
                },
                {
                    "name": "Geology",
                    "degree": "B.S."
                },
                {
                    "name": "Health Information Management",
                    "degree": "B.S."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Journalism",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics, Applied",
                    "degree": "B.A."
                },
                {
                    "name": "Medical Imaging Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Neuroscience and Behavior",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Portuguese and Lusophone World Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Psychiatric Rehabilitation and Psychology",
                    "degree": "B.S."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Social Work",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Urban Secondary Education",
                    "degree": "B.A."
                },
                {
                    "name": "Video Production",
                    "degree": "B.A."
                },
                {
                    "name": "Visual Arts",
                    "degree": "B.F.A."
                },
                {
                    "name": "Women's and Gender Studies",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "Rutgers Business School: Undergraduate-Newark",
            "source": {
                "label": "Rutgers Newark Undergraduate Catalog 2026-2027, Rutgers Business School, Academic Program Requirements",
                "url": "https://newark-undergrad-26-27.catalogs.rutgers.edu/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.S."
                },
                {
                    "name": "Finance",
                    "degree": "B.S."
                },
                {
                    "name": "Finance Real Estate",
                    "degree": "B.S."
                },
                {
                    "name": "Leadership and Management",
                    "degree": "B.S."
                },
                {
                    "name": "Management Science and Information Systems",
                    "degree": "B.S."
                },
                {
                    "name": "Marketing",
                    "degree": "B.S."
                },
                {
                    "name": "Supply Chain Management",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "School of Criminal Justice",
            "source": {
                "label": "Rutgers School of Criminal Justice, Undergraduate",
                "url": "https://rscj.newark.rutgers.edu/undergraduate/"
            },
            "majors": [
                {
                    "name": "Criminal Justice",
                    "degree": "B.S."
                },
                {
                    "name": "Justice Studies",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "School of Public Affairs and Administration",
            "source": {
                "label": "Rutgers Newark Undergraduate Catalog 2026-2027, School of Public Affairs and Administration",
                "url": "https://newark-undergrad-26-27.catalogs.rutgers.edu/"
            },
            "majors": [
                {
                    "name": "Public Administration",
                    "degree": "B.A."
                }
            ]
        }
    ]
};

export default majors;
